export const ChannelReachBackRequestStatus = {
    READ: 1,
    DELETED: 2,
};
